import { render, staticRenderFns } from "./GoodTableBasic.vue?vue&type=template&id=990f1558&"
import script from "./GoodTableBasic.vue?vue&type=script&lang=js&"
export * from "./GoodTableBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports